import AutoDepositsShow from "components/manage/auto_deposits/show.vue";

$(() => {
  new Vue({
    el: document.querySelector(".v-manage-auto-deposits-show-controller"),
    components: { AutoDepositsShow },
  });
});
